export const initialSignupFormValues = {
  email: "",
  firstName: "",
  lastName: "",
  country: "United States of America (the)",
  zipCode: "",
  resumeFile: null,
  howDidYouHear: "",
  referrerName: "",
  referrerEmail: "",
  otherDetails: "",
  documentReferrer: "",
};
